module.exports = __webpack_public_path__ + "static/media/social-media.35c079b4.jpg";